var _desc, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftonedrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Microsoft-Onedrive--Streamline-Svg-Logos",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Microsoft Onedrive Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0364b8",
    d: "m14.4475 14.6323 4.8507 -4.63885c-1.007575 -3.92885 -5.00935 -6.297 -8.938225 -5.289425 -1.769275 0.45375 -3.305975 1.55055 -4.310175 3.076275 0.0751 -0.0019 8.3977 6.852 8.3977 6.852Z",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "m9.211075 8.6536 -0.00025 0.0008c-0.92685 -0.57405 -1.9958 -0.8775 -3.086075 -0.876025 -0.025175 0 -0.049925 0.001625 -0.075075 0.0019C2.8067 7.82045 0.21030575 10.481975 0.25046 13.72495c0.014555 1.176375 0.3821225 2.321225 1.0550425 3.286225L8.572625 16.101l5.57155 -4.49255 -4.9331 -2.95485Z",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1490df",
    d: "M19.29795 9.9935c-0.106625 -0.007125 -0.2138 -0.01205 -0.322225 -0.01205 -0.650725 -0.00065 -1.2947 0.132275 -1.892 0.390525l-0.00015 -0.0005 -2.939525 1.237 3.240625 4.002975 5.793425 1.4083c1.2502 -2.320975 0.382175 -5.216 -1.9388 -6.466225 -0.599725 -0.32305 -1.2617 -0.514 -1.94135 -0.560025Z",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#28a8ea",
    d: "M1.30542 17.011175C2.4026925 18.5888 4.203025 19.529 6.1247 19.527975h12.851075c1.7555 0.0005 3.369525 -0.962825 4.20235 -2.508175L14.1441 11.60845 1.30542 17.011175Z",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftonedrive);
export default __webpack_public_path__ + "static/media/Microsoft onedrive.8b6087637b0997958a358a58382732cb.svg";
export { ForwardRef as ReactComponent };